<template>
  <div class="manager">
    <div class="set-manager">
      <el-button type="primary" class="manager-button" @click="manageSubmit">添加管理员</el-button>
      <el-table
        :data="managerList"
        style="width: 100%"
        class="table_row"
        :row-class-name="tableRowDisabled"
        v-loading="tableLoading"
      >
        <el-table-column prop="name" label="姓名">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
            <div class="name_id">ID:{{ scope.row.id }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column
          prop="qy_user_id"
          label="企业微信id"
          v-if="loginType === 2"
        ></el-table-column>
        <el-table-column prop="email" label="邮箱" v-if="loginType === 3"></el-table-column>
        <el-table-column prop="role" label="角色">
          <template slot-scope="scope">
            <div>{{ roleData[scope.row.role] || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="公众号权限">
          <template slot-scope="scope">
            <span v-if="scope.row.role == 1">全部权限</span>
            <span v-else v-for="(item, index) in scope.row.app_list" :key="index">
              <span v-if="index">、</span>
              {{ item.app_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="企业应用权限">
          <template slot-scope="scope">
            <span v-if="scope.row.role == 1">全部权限</span>
            <span v-else v-for="(item, index) in scope.row.agent_list" :key="index">
              <span v-if="index">、</span>
              {{ item.agent_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1" type="text" @click="editCol(scope.row)">
              编辑
            </el-button>
            <el-button type="text" @click="changeRowStatus(scope.row)">
              {{ scope.row.status == 1 ? '禁用' : '恢复' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_col">
        <el-pagination
          style="background-color: #ffffff"
          :total="total"
          :page-size="form.page_size"
          :current-page="form.page_index"
          @current-change="currentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="g_pageSizesConfig"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog
      class="release-dialog"
      :visible.sync="managerdialogVisible"
      :show-close="false"
      :center="true"
      width="376px"
    >
      <div>确定禁用该用户吗？</div>
      <div class="disable">（禁用后，该用户不可登录）</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="managerdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="managerconfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { updateManagerStatusApi, getManagerListApi, GetManagerUserGroup } from '@/api/setUser';
export default {
  name: 'SetManager',
  data() {
    return {
      tableLoading: false, // 管理员的列表loading
      managerdialogVisible: false, // 管理员禁用弹窗
      managerID: null, // 记录管理员禁用id
      dialogStatus: null, // 状态
      managerList: [],
      form: {
        page_index: 1,
        page_size: 10,
      },
      total: 0,
      roleData: {
        1: '管理员',
        2: '操作员',
      },
      loginType: 1, // 登录方式，1手机号，2企微，3 okta
    };
  },
  created() {
    this.form.page_size = this.g_pageSizeDefault;
    this.getManagerList();
    this.$store
      .dispatch('login/getLoginConfig')
      .then((res) => {
        console.log(res);
        this.loginType = res.login_type;
      })
      .catch((e) => this.$message.error(e));
    GetManagerUserGroup().then(({ GroupList }) => {
      for (const { Id, Name } of GroupList) {
        this.roleData[Id] = Name;
      }
    });
  },
  methods: {
    // 添加管理员
    manageSubmit() {
      this.$emit('changeComponet', 'managerDetails');
    },
    //  编辑管理员
    editCol(data) {
      if (data.id !== null && data.id !== undefined && data.id !== '') {
        this.$emit('changeComponet', 'managerDetails', { id: data.id });
      } else {
        this.$message.error('id为空,跳转失败');
      }
    },
    changeRowStatus(item) {
      this.managerID = item.id;
      if (item.status == 1) {
        // 要去禁用
        this.managerdialogVisible = true;
        this.dialogStatus = 2;
      } else if (item.status == 2) {
        // 要去启用
        this.dialogStatus = 1;
        this.managerDisable();
      }
    },
    // 获取列表
    async getManagerList(noReset) {
      this.tableLoading = true;
      await getManagerListApi(this.form)
        .then((res) => {
          if (!noReset) {
            this.managerList = [];
          }
          this.managerList = res.list;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
      this.tableLoading = false;
    },
    // 分页
    currentChange(e) {
      this.form.page_index = e;
      this.getManagerList();
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.form.page_size = e;
      this.getManagerList();
    },
    // 禁用管理员的弹窗确定
    managerconfirm() {
      this.managerdialogVisible = false;
      if (this.dialogStatus === 2) {
        this.managerDisable();
      }
    },
    managerDisable() {
      this.tableLoading = true;
      const form = { id: this.managerID, status: this.dialogStatus };
      updateManagerStatusApi(form)
        .then(() => {
          this.getManagerList(true);
          this.$message({
            message: '状态修改成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.tableLoading = false;
          this.$message.error(err.message);
        });
    },
    tableRowDisabled({ row }) {
      if (row.status === 2) {
        return 'disabled_table';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.manager {
  height: 100%;
  .set-manager {
    height: 100%;
    font-size: 16px;
    .manager-button {
      margin-bottom: 18px;
      float: right;
    }

    .table_row {
      font-size: 16px;

      ::v-deep.disabled_table {
        color: #c0c4cc !important;
      }

      .name_id {
        color: #909399;
      }
    }
  }
}

::v-deep.release-dialog {
  background: rgba(0, 0, 0, 0.5);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 32px 0 0px;
    text-align: center;
    color: #606266;
  }

  .el-dialog__footer {
    .el-button {
      border-radius: 100px;
      height: 40px;
      width: 96px;
      line-height: 0;
      margin-top: 28px;
    }

    .el-button--default {
      border: 1px solid #dcdfe6;
      font-weight: bold;
      color: #606266;
    }

    .el-button--primary {
      font-weight: bold;
      color: #ffffff;
      background: #ff6d42;
      border: none;
    }
  }

  .disable {
    font-size: 14px;
    color: #909399;
    letter-spacing: 0;
    text-align: center;
    margin-top: 15px;
  }

  .release-dialog ::v-deep .el-dialog {
    width: 376px;
    height: 174px;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    margin-top: 0vh !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
}

.el-button--text {
  font-size: 16px !important;
}
</style>
